export const dashboard = {
    "programactionByArea": "Programaciones por áreas",
    "programactionByDepartment": "Programaciones por departamentos",
    "kpi": {
      "titles": {
        "activedUnits": "Unidades programadas",
        "programmed": "Programaciones",
        "actionPlan": "Planes de acción"
      },
      "total": "Total",
      "inProgress": "En progreso",
      "noStarted": "No iniciados",
      "finished": "Finalizados",
      "rejected": "Rechazados",
      "expired": "Vencidos",
      "canceled": "Cancelados",
      "programmed": "Programados",
      "toStart": "Por iniciar",
      "noProgrammed": "No programados",
      "inclomplete": "Incompleto"
    },
    "href": {
      "indicators-units": "Unidades programadas",
      "indicators-programations": "Programaciones",
      "indicators-action-plan": "Planes de acción",
      "indicators-progress": "Acciones programadas",
      "divisions": "Cumplimiento de programación semanal",
      "filterDivision": "Filtro de programación semanal",
      "completing-questionnaires": "Nivel de cumplimiento por usuario",
      "folios-areas": "Folios por área",
      "folios-department": "Folios por departamento",
      "folios-indicator": "Indicador de folios",
      "top-results": "Top de resultados",
      "results-tabulator": "Tabulador de resultados",
      "area-histogram": "Histórico de programaciones por área",
      "department-histogram": "Histórico de programaciones por departamento"
    },
    "data": {
      "year": "Año",
      "month": "Mes",
      "week": "Semana",
      "unitId": "ID",
      "unit": "Unidad",
      "country": "País",
      "state": "Estado",
      "department": "Departamento",
      "city": "Ciudad",
      "city_id": "",
      "zone_id": "",
      "zone": "Zona",
      "class": "Clase",
      "division": "División",
      "division_id": "",
      "cve": "CVE",
      "role": "Rol",
      "role_id": "",
      "userType": "Tipo de usuario",
      "user_type_id": "",
      "curp": "CURP",
      "user": "Usuario",
      "user_id": "",
      "questionnaire": "Cuestionario",
      "qestionnaire_id": "",
      "questionnaire_status": "Estatus del cuestionario",
      "questionnaire_status_id": "",
      "area": "Área",
      "area_id": "",
      "department_id": "",
      "start_date": "Fecha de inicio",
      "start_hour": "Hora de inicio",
      "end_date": "Fecha de fin",
      "end_hour": "Hora de fin",
      "application_time": "Hora de aplicación",
      "result": "Resultado"
    },
    "dataSettings": {
      "title": "Reporte de programaciones",
      "title2": "Reporte de programaciones por área y departamento"
    },
    "indicators": {
      "modal": {
        "title": {
          "unit": "Filtrar unidades programadas",
          "programmed": "Filtrar programaciones",
          "actionPlan": "Filtrar planes de acción"
        }
      },
      "titles": {
        "units": "Unidades programadas",
        "programming": "Programaciones",
        "actionPlan": "Planes de acción"
      },
     "completingQuestionnaires": {
        "title": "Nivel de cumplimiento por usuario",
        "lastUpdate": "Última actualización: Semana: ",
        "totalgenerals": "Totales generales",
        "totalPrograming": "Total de programaciones",
        "ownScheduling": "Mis programaciones",
        "user": "Usuario",
        "programing": "Programaciones",
        "noExecuted": "No ejecutado",
        "finished": "Finalizado",
        "result": "Resultado",
        "redirect": "Redirigir",
        "manager": "Gerente",
        "supervisor": "Supervisor",
        "hierarchyUsers": "Usuarios de jerarquías"
     }
    }
  }